export enum FieldTypeIcon {
  text = 'free-text',
  dropdown = 'dropdown-list',
}
